module.exports = __webpack_public_path__ + "static/media/not-found-404.0fe90003.svg";